import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "childPanel", "detailsPanel", "detailsIcon", "detailsToggle"]

  connect() {
    // Auto-load first tab
    if (this.tabTargets.length > 0) {
      this.loadTab(this.tabTargets[0])
    }
  }

  switchTab(event) {
    const clickedTab = event.currentTarget

    // Update tab styles
    this.tabTargets.forEach(tab => {
      tab.classList.remove('text-purple-700', 'border-purple-600')
      tab.classList.add('text-gray-500', 'border-transparent')
    })
    clickedTab.classList.remove('text-gray-500', 'border-transparent')
    clickedTab.classList.add('text-purple-700', 'border-purple-600')

    this.loadTab(clickedTab)
  }

  loadTab(tab) {
    const url = tab.dataset.childDataUrl
    if (!url) return

    const panel = this.childPanelTarget
    panel.innerHTML = '<div class="p-6"><div class="flex items-center justify-center py-8"><div class="lz-spinner-icon h-6 w-6"></div></div></div>'

    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(response => response.text())
      .then(html => {
        panel.innerHTML = '<div class="p-6">' + html + '</div>'
      })
      .catch(() => {
        panel.innerHTML = '<div class="p-6 text-center text-red-500 text-sm">Failed to load data</div>'
      })
  }

  loadMore(event) {
    const url = event.currentTarget.dataset.url
    if (!url) return

    const panel = this.childPanelTarget
    panel.innerHTML = '<div class="p-6"><div class="flex items-center justify-center py-8"><div class="lz-spinner-icon h-6 w-6"></div></div></div>'

    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(response => response.text())
      .then(html => {
        panel.innerHTML = '<div class="p-6">' + html + '</div>'
      })
      .catch(() => {
        panel.innerHTML = '<div class="p-6 text-center text-red-500 text-sm">Failed to load data</div>'
      })
  }

  toggleDetails() {
    if (this.hasDetailsPanelTarget) {
      this.detailsPanelTarget.classList.toggle('hidden')
    }
    if (this.hasDetailsIconTarget) {
      this.detailsIconTarget.classList.toggle('rotate-180')
    }
  }
}
